import type { LegacyTournament } from "../api/legacyTypes";

const statusRank: Record<string, number> = {
  ongoing: 0,
  upcoming: 1,
  completed: 3,
};

function dateValue(value: string, fallback: number) {
  const parsed = Date.parse(value);
  return Number.isFinite(parsed) ? parsed : fallback;
}

export function sortTournamentsForCatalogue(tournaments: LegacyTournament[]) {
  return [...tournaments].sort((left, right) => {
    const leftStatus = left.catalogueStatus.toLowerCase();
    const rightStatus = right.catalogueStatus.toLowerCase();
    const rankDifference = (statusRank[leftStatus] ?? 2) - (statusRank[rightStatus] ?? 2);
    if (rankDifference !== 0) return rankDifference;

    if (leftStatus === "completed") {
      return dateValue(right.endDate, Number.NEGATIVE_INFINITY) - dateValue(left.endDate, Number.NEGATIVE_INFINITY);
    }
    if (leftStatus === "ongoing") {
      return dateValue(left.endDate, Number.POSITIVE_INFINITY) - dateValue(right.endDate, Number.POSITIVE_INFINITY);
    }
    return dateValue(left.startDate, Number.POSITIVE_INFINITY) - dateValue(right.startDate, Number.POSITIVE_INFINITY);
  });
}
